<script setup lang="ts">
import SvgIcon from "../SvgIcon.vue";
import Loader from "~/components/Common/Loader.vue";

defineEmits(["update:modelValue"]);
const props = defineProps({
  asyncAction: {
    type: Function,
    required: true,
  },
  textConfirm: {
    type: String,
  },
  nameIcon: {
    type: String,
  },
});

const loading = ref(false);

async function handleClick() {
  if (loading.value) return;
  loading.value = true;
  try {
    await props.asyncAction();
  } catch (err) {
    console.error("Erreur dans asyncAction :", err);
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <button
    class="flex gap-1 items-center text-primary-blue-color cursor-pointer"
    :disabled="loading"
    @click="handleClick"
  >
    <div v-if="nameIcon" class="flex gap-2 items-center" :class="{ 'cursor-default': loading }">
      <Loader v-if="loading" :width="16" :height="16"></Loader>
      <SvgIcon v-else-if="nameIcon" class="cursor-pointer w-[16px] h-[16px]" :name="nameIcon"></SvgIcon>
      <span class="body_regular">{{ textConfirm }}</span>
    </div>
  </button>
</template>

<style scoped></style>
